export default __webpack_public_path__ + "static/media/immunizationtracker.71b162aa.png";